function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import cn from 'classnames';
import text from '../../text';
import Icon from '../icon/Icon';
var CartButton = function(_param) {
    var // if true, the icon will show an X;
    // if false, the icon will show a cart with a badge of the number of items in the cart
    open = _param.open, className = _param.className, count = _param.count, rest = _object_without_properties(_param, [
        "open",
        "className",
        "count"
    ]);
    return /*#__PURE__*/ React.createElement(Button, _object_spread({
        variant: "outline-primary",
        className: cn('cart-button', className, open && 'open')
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "wrapper"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: open ? 'close-box' : 'shopping-cart'
    }), /*#__PURE__*/ React.createElement("span", {
        className: "text"
    }, text('cart')), !open && /*#__PURE__*/ React.createElement(Badge, {
        pill: true,
        variant: "danger",
        className: "badge-count"
    }, count)));
};
export default CartButton;
